"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logError;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _monitoringHelpers = require("ui-addon-upgrades/_core/common/reliability/monitoringHelpers");

function logError(product, location) {
  return _apiClient.default.post(_monitoringHelpers.submitPath, {
    data: (0, _monitoringHelpers.createPayload)(product, location),
    query: _monitoringHelpers.buckyQueryData
  });
}

module.exports = exports.default;